"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const changeOrderInNutritionFacts_1 = __importDefault(require("./changeOrderInNutritionFacts"));
const IconWithLabel_1 = require("../../atoms/icons/IconWithLabel");
const renderNutrientFacts = (nutritionFacts, translations, unit) => {
    const elements = [];
    const orderedFacts = (0, changeOrderInNutritionFacts_1.default)(nutritionFacts);
    for (const fact in orderedFacts) {
        const fixUnit = fact === "calories" ? "" : unit;
        elements.push((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.P, { children: `${orderedFacts[fact]} ${fixUnit}` }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: translations[fact] }, void 0)] }, fact));
    }
    return (0, jsx_runtime_1.jsx)(FactsWrapper, { children: elements }, void 0);
};
exports.default = ({ name, shouldRenderMealPlanIcon, nutritionFacts, translations, unit }) => {
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsxs)("div", { "data-cy": "nutrition-meal-header-title", children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { children: name }, void 0), shouldRenderMealPlanIcon && ((0, jsx_runtime_1.jsx)(IconWithLabel_1.IconWithLabel, { icon: ["fal", "hat-chef"], label: "Menu" }, void 0))] }, void 0), (0, jsx_runtime_1.jsx)("div", { children: nutritionFacts &&
                    renderNutrientFacts(nutritionFacts, translations, unit) }, void 0)] }, void 0));
};
const Wrapper = styled_components_1.default.div `
  align-items: center;
  cursor: pointer;
  display: flex;
  flex: 1;
  justify-content: space-between;

  h2 {
    margin-bottom: 0;
  }

  & > div:first-of-type {
    flex: 2;

    @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: ${({ theme }) => theme.spacings.m};
    }
  }

  & > div:last-of-type {
    flex: 3;
    display: flex;
    width: 100%;

    @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
      flex-grow: 0;
    }

    & > div {
      margin-left: 2px;

      @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
        margin-left: 0;
      }
    }
  }
`;
const FactsWrapper = styled_components_1.default.div `
  display: flex;
  flex: 1;
  justify-content: flex-end;

  & > div {
    align-items: flex-start;
    display: flex;
    flex: 1;
    flex-direction: column;
  }

  p {
    color: ${({ theme }) => theme.colors.greyLighten40};
    display: inline-block;
    font-size: 0.875rem;
    margin-bottom: 0;
  }

  p:last-of-type {
    text-transform: lowercase;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    justify-content: flex-end;

    & > div {
      flex-direction: row;
      justify-content: flex-end;
      margin-right: ${({ theme }) => theme.spacings.s};
    }

    & > div:not(:first-of-type) {
      display: none;
    }

    p {
      color: ${({ theme }) => theme.colors.greyBase};
      font-size: 1rem;
    }
  }
`;
//# sourceMappingURL=MealHeader.js.map